import { useState, useEffect } from "react";
import { RevenueChart } from "components/charts";
import { ChartLayout } from "layouts";
import { Spinner } from "components";

function Revenue({
  revenueData = { categories: [], data: [], loading: false, error: null },
  setDateRange,
}) {
  const [fadeIn, setFadeIn] = useState(false);
  const { categories = [], data = [], loading, error } = revenueData;

  const processChartData = () => {
    if (
      !Array.isArray(data) ||
      data.length === 0 ||
      !Array.isArray(categories)
    ) {
      return { percentageData: [], rawData: [] };
    }

    // Sum all revenue values
    const totalRevenue = data.reduce((sum, value) => sum + value, 0) || 1; // Avoid division by 0
    // Calculate percentage of total for each month
    const percentageData = data.map((value) =>
      totalRevenue === 0 ? 0 : Math.round((value / totalRevenue) * 100)
    );

    return { percentageData, rawData: data };
  };

  const { percentageData, rawData } = processChartData();

  useEffect(() => {
    if (loading) {
      setFadeIn(false);
    } else {
      const timer = setTimeout(() => {
        setFadeIn(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  return (
    <ChartLayout
      title="Total Revenue"
      isDateFilter={true}
      setDate={setDateRange}
    >
      {loading ? (
        <div className="flex flex-col items-center justify-center h-full p-4 min-h-96 transition-opacity duration-300 ease-in-out">
          <div className="animate-pulse">
            <Spinner size="large" color="#19a8a6" />
          </div>
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-full transition-opacity duration-300 ease-in-out">
          <div className="text-red-500">Error loading revenue data</div>
        </div>
      ) : (
        <div
          className={`w-full flex-1 flex flex-col py-4 transition-opacity duration-300 ease-in-out ${
            fadeIn ? "opacity-100" : "opacity-0"
          }`}
        >
          <RevenueChart
            percentageData={percentageData}
            rawData={rawData}
            categories={categories}
            key={`revenue-container-${JSON.stringify(
              categories
            )}-${JSON.stringify(data)}`}
          />
        </div>
      )}
    </ChartLayout>
  );
}

export default Revenue;
